<template>
    <li :class="classes" @click="handleClick($event)"><slot></slot></li>
</template>
<script>
    const prefixCls = 'ivu-dropdown-item';
    import { findComponentUpward } from '../../utils/assist';
    export default {
        name: 'DropdownItem',
        props: {
            name: {
                type: [String, Number]
            },
            disabled: {
                type: Boolean,
                default: false
            },
            selected: {
                type: Boolean,
                default: false
            },
            divided: {
                type: Boolean,
                default: false
            },
            showTrace: {
              type: Boolean,
              default: false
            }
        },
        computed: {
            classes () {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-disabled`]: this.disabled,
                        [`${prefixCls}-selected`]: this.selected,
                        [`${prefixCls}-divided`]: this.divided
                    }
                ];
            }
        },
        methods: {
            handleClick (e) {
                if (this.disabled) return;
                const $parent = findComponentUpward(this, 'Dropdown');
                const hasChildren = this.$parent && this.$parent.$options.name === 'Dropdown';

                if (hasChildren) {
                    this.$parent.$emit('on-haschild-click');
                } else {
                    if ($parent && $parent.$options.name === 'Dropdown') {
                        $parent.$emit('on-hover-click');
                    }
                }
                this.setLiAttribute(e);
                $parent.$emit('on-click', this.name);
            },
            setLiAttribute(e, curDom) {
              if (this.showTrace) {
                this.removeAddAttribute();
                const dom = e ? e.currentTarget : curDom;
                dom.setAttribute('currentClick', true);
              }
            },
            removeAddAttribute() {
                const clickedList = document.querySelectorAll('li[currentClick=true]');
                Array.from(clickedList).forEach(clicked => {
                  clicked.removeAttribute('currentClick');
                });
            }
        },
    };
</script>
<style scoped>
  li[currentClick=true] {
    background-color: #0083ec;
    color: #fff;
  }
</style>
